import { render, staticRenderFns } from "./SearchFooter.vue?vue&type=template&id=0263a3d1&"
import script from "./SearchFooter.vue?vue&type=script&lang=js&"
export * from "./SearchFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports